import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import {
  Button,
} from "reactstrap";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

import widgetCard from "../../../assets/images/icons-component/card.png";
import CardBackImg from "../../../assets/images/card/card_back.png";
import ShuffleImg from "../../../assets/images/icons/WIDGET_CARD_SHUFFLE.svg";

import { Portal } from "../../../utils/components";

import setting from "../../../assets/images/icons/console-6.svg";
import lightSetting from "../../../assets/images/icons/console-6.svg";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const ANIMATION_DURATION = 100;

const Index: any = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const { config, zoom, onUpdate, actionEnd, save, setIsOpen, socketRequest, boardInfoId, itemSpotlight, inside, popupRef, hoverCard, nowPage } = props;
  const [deck, setDeck] = useState<any[]>([]);
  const [drawnCards, setDrawnCards] = useState<any[]>([]);
  const animatingCardRef = useRef<{
    card: any;
    progress: number;
    direction: "draw" | "recall";
  } | null>(null);
  const [isShuffling , setIsShuffling] = useState<boolean>(false);
  
  const [Fisrt , setFisrt] = useState<boolean>(true);

  const [cardTitle, setCardTitle] = useState<string>(config.data?.title? config.data?.title : "");

  const coverRef = useRef<HTMLDivElement>(null);
  const staticCanvasRef = useRef<HTMLCanvasElement>(null);     // 用於靜態背景 + 靜態卡片
  const animationCanvasRef = useRef<HTMLCanvasElement>(null);  // 專門用來畫翻卡動畫

  const [lastTapTimestamp, setLastTapTimestamp] = useState(0);
  const [Spotlighting , setSpotlighting] = useState<boolean>(false);

  // 
  const [isIPad, setIsIPad] = useState<boolean>( /iPad/.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document));
  // 
  // 
  // 快取卡片文字測量結果（含 maxWidth & maxFontSize 作為 key）
  const textMeasureCache = useRef<Record<string, Record<string, { fontSize: number; lines: string[] }>>>({});

  const cardImg = useRef<HTMLImageElement | null>(null);
  const buttonImg = useRef<HTMLImageElement | null>(null);
  const loadImage = (imagePath: string): Promise<void> => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = imagePath;
      img.onload = () => {
        cardImg.current = img;
        resolve();
      };
      img.onerror = () => {
        console.error("載入圖片失敗:", imagePath);
        resolve();
      };
    });
  };
  const loadButtonImage = (imagePath: string): Promise<void> => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = imagePath;
      img.onload = () => {
        buttonImg.current = img;
        resolve();
      };
      img.onerror = () => {
        console.error("按鈕圖載入失敗:", imagePath);
        resolve();
      };
    });
  };

  const getCachedTextMetrics = (
    ctx: CanvasRenderingContext2D,
    text: string,
    maxWidth: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const key = `${maxWidth}_${maxFontSize}_${minFontSize}`;
    if (!textMeasureCache.current[text]) textMeasureCache.current[text] = {};
    if (textMeasureCache.current[text][key]) return textMeasureCache.current[text][key];

    ctx.font = `${maxFontSize}px Arial`;
    let fontSize = maxFontSize;

    while (fontSize > minFontSize) {
      if (ctx.measureText(text).width <= maxWidth) break;
      fontSize -= 1;
      ctx.font = `${fontSize}px Arial`;
    }

    const words = text.split('');
    let line = '';
    const lines: string[] = [];
    for (const w of words) {
      const test = line + w;
      if (ctx.measureText(test).width > maxWidth && line !== '') {
        lines.push(line);
        line = w;
      } else {
        line = test;
      }
    }
    if (line) lines.push(line);

    const result = { fontSize, lines };
    textMeasureCache.current[text][key] = result;
    return result;
  };

  /**
   * 快取文字 + 任意位置繪製
   * @param ctx 畫布上下文
   * @param text 要繪製的文字
   * @param x 中心 X 座標
   * @param y 中心 Y 座標
   * @param maxWidth 最大寬度
   * @param maxFontSize 最大字體大小
   * @param minFontSize 最小字體大小
   * @param alignX 水平對齊 center / left / right
   * @param alignY 垂直對齊 middle / top / bottom
   */
  const drawCachedWrappedText = (
    ctx: CanvasRenderingContext2D,
    text: string,
    x: number,
    y: number,
    maxWidth: number,
    maxFontSize: number,
    minFontSize: number,
    alignX: CanvasTextAlign = 'center',
    alignY: CanvasTextBaseline = 'middle'
  ) => {
    const { fontSize, lines } = getCachedTextMetrics(ctx, text, maxWidth, maxFontSize, minFontSize);
    ctx.font = `${fontSize}px Arial`;
    ctx.textAlign = alignX;
    ctx.textBaseline = 'middle';

    const totalHeight = lines.length * fontSize + (lines.length - 1) * 10;
    let baseY = y;

    if (alignY === 'top') baseY = y + fontSize / 2;
    else if (alignY === 'bottom') baseY = y - totalHeight + fontSize / 2;
    else baseY = y - totalHeight / 2 + fontSize / 2;

    lines.forEach(line => {
      ctx.fillText(line, x, baseY);
      baseY += fontSize + 10;
    });
  };
  
  useEffect(() => {
    if (config.data && config.data.deck && !Fisrt) {
      if (config.data?.action !== "shuffle" && config.data?.action !== "drawnToShuffle") {
        setDeck(config.data?.deck);
        setDrawnCards(config.data?.drawnCards);
      }
      if (config.data?.triggered) {
        if (config.data?.action) {
          if (config.data?.action === "shuffle") {
            const shuffleTemp = Array.from(config.data?.drawnCards);
            for (let i = 0; i < shuffleTemp.length; i++) {
              startAnimation(shuffleTemp[i], "recall");
            }
            setTimeout(() => {
              setDeck(config.data?.deck);
              setDrawnCards(config.data?.drawnCards);
            }, 500);
          } else if (config.data?.action === "drawnToShuffle") {
            triggeredShuffleDeck();
          } else {
            startAnimation(config.data?.drawNow, config.data?.action, config.data?.triggered);
          }
        }
        delete config.data.triggered;
      }
    }
  }, [config.data?.deck, config.data?.drawnCards, config.data?.drawNow, Fisrt]);

  useEffect(() => {
    setCardTitle(config.data?.title);
  }, [config.data?.title]);

  useEffect(() => {
    (async () => {
      await loadImage(CardBackImg);
      await loadButtonImage(ShuffleImg);
      if (!username) {
        const shuffled = shuffleAndFormat(config.data.cardList);
        if (config.data?.deck.length === 0) {
          setDeck(shuffled);
          setDrawnCards([]);
        } else {
          if (Fisrt) {
            setDeck(shuffled);
            setDrawnCards([]);
          } else {
            setDeck(config.data?.deck);
            setDrawnCards(config.data?.drawnCards);
          }
        }
        animatingCardRef.current = null;
        if (config.data && config.data.deck) {
          const data = config.data;
          if (config.data?.drawnCards.length === 0) {
            data.deck = shuffled;
            data.drawnCards = [];
          } else {
            data.deck = config.data?.deck;
            data.drawnCards = config.data?.drawnCards;
          }
          onUpdate({ id: config.id, data: {...data} });
        }
      } else {
        if (config.data && config.data.deck) {
          const shuffled = shuffleAndFormat(config.data.cardList);
          if (config.data.deck.length === 0) {
            setDeck(shuffled);
            setDrawnCards([]);
          } else {
            setDeck(config.data.deck);
            setDrawnCards(config.data?.drawnCards);
          }
        }
        setFisrt(false);
      }
    })();
  }, [config.data.cardList, Fisrt]);

  useEffect(() => {
    if (!username && save) {
      if (config.data) {
        const data = config.data;
        data.start = save;
        onUpdate({ id: config.id, data: {...data} });
      }
    }
  }, [save]);

  const shuffleAndFormat = (cardList: string[]) => {
    return cardList
      .sort(() => Math.random() - 0.5)
      .map((text, idx) => ({ text, idx }));
  };

  const startAnimation = (card: any, direction: "draw" | "recall", triggered: boolean = false) => {
    animatingCardRef.current = { card, progress: 0, direction };
  
    const startTime = performance.now();
    const animate = (time: number) => {
      const elapsed = time - startTime;
      const progress = Math.min(elapsed / (ANIMATION_DURATION * 2), 2); // 0~2 先移動再翻轉
  
      animatingCardRef.current!.progress = progress;

      // 加這段：渲染動畫畫面
      if (animationCanvasRef.current && cardImg.current) {
        const ctx = animationCanvasRef.current.getContext("2d");
        if (ctx) {
          ctx.clearRect(0, 0, animationCanvasRef.current.width, animationCanvasRef.current.height);
          renderCardFlipAnimation(
            ctx,
            animatingCardRef.current,     // 包含 card, progress, direction
            deck,
            drawnCards,
            animationCanvasRef.current,
            cardImg.current,
            drawCachedWrappedText,
            drawRoundedRect
          );
        }
      }
      // 
  
      if (progress < 2) {
        requestAnimationFrame(animate);
        if (direction === "draw") {
          setDeck((prev) => prev.filter((c) => c.text !== card.text).sort((a, b) => a.idx - b.idx));
        } else {
          setDrawnCards((prev) => prev.filter((c) => c.text !== card.text));
        }
      } else {
        finishAnimation(card, direction, triggered);
      }
    };
  
    requestAnimationFrame(animate);
  };

  const finishAnimation = (card: any, direction: "draw" | "recall", triggered: boolean = false) => {
    animatingCardRef.current = null;

    // 
    const canvas = animationCanvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext("2d");
      setTimeout(() => {
        ctx?.clearRect(0, 0, canvas.width, canvas.height);
      }, 1000);
    }
    // 

    if (direction === "draw") {
      setDrawnCards((prev) => [...prev, card]);
      if (!triggered) {
        if (deck.length === 1) {
          shuffleDeck(true);
        }
      } else {
        if (deck.length === 0) {
          triggeredShuffleDeck();
        }
      }
    } else {
      setDeck((prev) => {
        const updatedDeck = [card, ...prev];
        return updatedDeck.sort((a, b) => a.idx - b.idx);
      });
    }
  };

  const shuffleDeck = useCallback((last: boolean = false) => {
    if (animatingCardRef.current || isShuffling) return;
    setIsShuffling(true);

    const ANIMATION_DURATION = 400; // 動畫總時長
    const SPLIT_RATIO = 0.5; // 分開階段占總時長的比例
    const MAX_CYCLES = 3; // 最大動畫循環次數
    let currentCycle = 0; // 當前循環次數
    let startTime = 0; // 每次循環的起始時間

    const easeInOutQuad = (t: number) =>
      t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

    const animate = (time: number) => {
      if (startTime === 0) startTime = time; // 初始化起始時間
      const elapsed = time - startTime;
      const overallProgress = Math.min(elapsed / ANIMATION_DURATION, 1);

      const splitPhaseEnd = SPLIT_RATIO; // 分開階段的結束進度
      let progress = 0;
      let isSplitPhase = true;

      if (overallProgress <= splitPhaseEnd) {
        // 分開階段
        progress = overallProgress / splitPhaseEnd;
        isSplitPhase = true;
      } else {
        // 合併階段
        progress = (overallProgress - splitPhaseEnd) / (1 - splitPhaseEnd);
        isSplitPhase = false;
      }

      renderSplitAndMergeFrameWithOffset(progress, isSplitPhase);

      if (overallProgress < 1) {
        requestAnimationFrame(animate);
      } else {
        currentCycle++;
        if (currentCycle < MAX_CYCLES) {
          startTime = 0; // 重置起始時間
          requestAnimationFrame(animate); // 開始下一次動畫循環
        } else {   
          let last_drawn: any = null;
          let new_arr = Array.from(drawnCards);
          if (last && deck.length === 1) {
            last_drawn = Array.from(deck)[0];
            new_arr = new_arr.filter((c) => c.idx !== last_drawn.idx);
            last_drawn.idx = [...deck, ...drawnCards].length - 1;
          }
          const allCards = last? [...new_arr] : [...deck, ...new_arr];
          const shuffled = allCards
                            .sort(() => Math.random() - 0.5)
                            .map((card, index) => ({
                              ...card,
                              idx: index,
                            }));
          setDeck(shuffled);
          setDrawnCards(last_drawn? [last_drawn] : []);
          setIsShuffling(false); // 動畫完成
          if (config.data && config.data.deck) {
            const data = config.data;
            data.deck = shuffled;
            data.drawnCards = last_drawn? [last_drawn] : [];
            data.drawNow = "";
            data.action = last_drawn? "drawnToShuffle" : "shuffle";

            if (!username) {
              onUpdate({ id: config.id, data: {...data} });
              (async () => {
                const response = await socketRequest("updateWidget", {
                  trigger: username,
                  boardInfoId: boardInfoId,
                  widget: { id: config.id, data: {...data} },
                  cardAction: true
                });
                // console.log(response);
              }) ();
            }
          }
        }
      }
    };

    const renderSplitAndMergeFrameWithOffset = (
      progress: number,
      isSplitPhase: boolean
    ) => {
      const canvas = animationCanvasRef.current;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      const width = canvas.width;
      const height = canvas.height;

      ctx.clearRect(0, 0, width, height);

      const cardWidth = width * 0.425;
      const cardHeight = height * 0.555;

      const borderRadius = 20;

      const deckX = width * 0.03;
      const deckY = height * 0.3;
      let lastY = 0;
      let cardSpacing = 3;
      const splitDistance = width * 0.25; // 最大分開距離
      const offsetDistance = cardWidth * 1.1; // 左右堆的偏移量

      // 左側牌堆
      const old_arr = Array.from(drawnCards);
      if (deck.length === 1) {
        old_arr.splice(-1, 1);
      }
      [...deck, ...old_arr]
      .sort((a, b) => a.idx - b.idx)
      .forEach((_, i) => {
        cardSpacing = (i % 5 === 0) ? 3.03 : 3;
        const isLeft = i % 2 === 0; // 判斷是左邊還是右邊
        const targetX = (isSplitPhase ? isLeft : !isLeft)
          ? deckX - splitDistance + offsetDistance // 左堆偏移向右
          : deckX + splitDistance - offsetDistance; // 右堆偏移向左

        // 動態計算偏移：分開時增加偏移，合併時減少偏移
        const cardX = isSplitPhase
          ? deckX + (targetX - deckX) * easeInOutQuad(progress) // 分開
          : targetX + (deckX - targetX) * easeInOutQuad(progress); // 合併

        const cardY = i <= 20? ( deckY - i * cardSpacing ) : lastY;
        if (i <= 20) {
          lastY = cardY;
        }

        // 繪製卡片
        if (cardImg.current) {
          ctx.drawImage(cardImg.current, cardX, cardY, cardWidth, cardHeight);
        }
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#5d5b53";
        ctx.stroke();
      });
    };
    requestAnimationFrame(animate);
  }, [animatingCardRef.current, deck, drawnCards, cardImg.current]);

  
  const triggeredShuffleDeck = useCallback(() => {
    if (animatingCardRef.current || isShuffling) return;
    setIsShuffling(true);

    const ANIMATION_DURATION = 400; // 動畫總時長
    const SPLIT_RATIO = 0.5; // 分開階段占總時長的比例
    const MAX_CYCLES = 3; // 最大動畫循環次數
    let currentCycle = 0; // 當前循環次數
    let startTime = 0; // 每次循環的起始時間

    const easeInOutQuad = (t: number) =>
      t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

    const animate = (time: number) => {
      if (startTime === 0) startTime = time; // 初始化起始時間
      const elapsed = time - startTime;
      const overallProgress = Math.min(elapsed / ANIMATION_DURATION, 1);

      const splitPhaseEnd = SPLIT_RATIO; // 分開階段的結束進度
      let progress = 0;
      let isSplitPhase = true;

      if (overallProgress <= splitPhaseEnd) {
        // 分開階段
        progress = overallProgress / splitPhaseEnd;
        isSplitPhase = true;
      } else {
        // 合併階段
        progress = (overallProgress - splitPhaseEnd) / (1 - splitPhaseEnd);
        isSplitPhase = false;
      }

      renderSplitAndMergeFrameWithOffset(progress, isSplitPhase);

      if (overallProgress < 1) {
        requestAnimationFrame(animate);
      } else {
        currentCycle++;
        if (currentCycle < MAX_CYCLES) {
          startTime = 0; // 重置起始時間
          requestAnimationFrame(animate); // 開始下一次動畫循環
        } else {   
          let last_drawn: any = null;
          let new_arr = Array.from(config.data.drawnCards);
          if (config.data.deck.length === 1) {
            last_drawn = Array.from(config.data.deck)[0];
            new_arr = new_arr.filter((c: any) => c.idx !== last_drawn.idx);
            last_drawn.idx = [...config.data.deck, ...config.data.drawnCards].length - 1;
          }
          const allCards = [...config.data.deck, ...new_arr];
          const shuffled = allCards
                            .sort(() => Math.random() - 0.5)
                            .map((card, index) => ({
                              ...card,
                              idx: index,
                            }));
          setDeck(shuffled);
          setDrawnCards(last_drawn? [last_drawn] : []);
          setIsShuffling(false); // 動畫完成
          if (config.data && config.data.deck) {
            const data = config.data;
            data.deck = shuffled;
            data.drawnCards = last_drawn? [last_drawn] : [];
            data.drawNow = "";
            data.action = last_drawn? "drawnToShuffle" : "shuffle";

            if (!username) {
              onUpdate({ id: config.id, data: {...data} });
              (async () => {
                const response = await socketRequest("updateWidget", {
                  trigger: username,
                  boardInfoId: boardInfoId,
                  widget: { id: config.id, data: {...data} },
                  cardAction: true
                });
                // console.log(response);
              }) ();
            }
          }
        }
      }
    };

    const renderSplitAndMergeFrameWithOffset = (
      progress: number,
      isSplitPhase: boolean
    ) => {
      const canvas = animationCanvasRef.current;
      if (!canvas) return;

      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      const width = canvas.width;
      const height = canvas.height;

      ctx.clearRect(0, 0, width, height);

      const cardWidth = width * 0.425;
      const cardHeight = height * 0.555;

      const borderRadius = 20;

      const deckX = width * 0.03;
      const deckY = height * 0.3;
      let lastY = 0;
      let cardSpacing = 3;
      const splitDistance = width * 0.25; // 最大分開距離
      const offsetDistance = cardWidth * 1.1; // 左右堆的偏移量

      // 左側牌堆
      const old_arr = Array.from(config.data.drawnCards);
      if (config.data.deck.length === 1) {
        old_arr.splice(-1, 1);
      }
      [...config.data.deck, ...old_arr]
      .sort((a, b) => a.idx - b.idx)
      .forEach((_, i) => {
        cardSpacing = (i % 5 === 0) ? 3.03 : 3;
        const isLeft = i % 2 === 0; // 判斷是左邊還是右邊
        const targetX = (isSplitPhase ? isLeft : !isLeft)
          ? deckX - splitDistance + offsetDistance // 左堆偏移向右
          : deckX + splitDistance - offsetDistance; // 右堆偏移向左

        // 動態計算偏移：分開時增加偏移，合併時減少偏移
        const cardX = isSplitPhase
          ? deckX + (targetX - deckX) * easeInOutQuad(progress) // 分開
          : targetX + (deckX - targetX) * easeInOutQuad(progress); // 合併

        const cardY = i <= 20? ( deckY - i * cardSpacing ) : lastY;
        if (i <= 20) {
          lastY = cardY;
        }

        // 繪製卡片
        if (cardImg.current) {
          ctx.drawImage(cardImg.current, cardX, cardY, cardWidth, cardHeight);
        }
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#5d5b53";
        ctx.stroke();
      });
    };
    requestAnimationFrame(animate);
  }, [animatingCardRef.current, config.data.deck, config.data.drawnCards, cardImg.current]);

  const drawCard = useCallback(() => {
    if (animatingCardRef.current || isShuffling || deck.length === 0) return;
    const card = deck[deck.length - 1];
    startAnimation(card, "draw");

    if (config.data && config.data.deck) {
      const data = config.data;
      data.deck = deck.filter((c) => c.text !== card.text).sort((a, b) => a.idx - b.idx);
      data.drawnCards = [...drawnCards, card];
      data.drawNow = card;
      data.action = "draw";
      onUpdate({ id: config.id, data: {...data} });
      (async () => {
        const response = await socketRequest("updateWidget", {
          trigger: username,
          boardInfoId: boardInfoId,
          widget: { id: config.id, data: {...data} },
          cardAction: true
        });
        // console.log(response);
      }) ();
    }
  }, [deck, drawnCards]);

  const recallCard = useCallback(() => {
    if (animatingCardRef.current || isShuffling || drawnCards.length === 0) return;
    const card = drawnCards[drawnCards.length - 1];
    startAnimation(card, "recall");

    if (config.data && config.data.deck) {
      const data = config.data;
      data.deck = [...deck, card];
      data.drawnCards = drawnCards.filter((c) => c.text !== card.text);
      data.drawNow = card;
      data.action = "recall";
      onUpdate({ id: config.id, data: {...data} });
      (async () => {
        const response = await socketRequest("updateWidget", {
          trigger: username,
          boardInfoId: boardInfoId,
          widget: { id: config.id, data: {...data} },
          cardAction: true
        });
        // console.log(response);
      }) ();
    }
  }, [deck, drawnCards]);

  const drawRoundedRect = (
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    radius: number
  ) => {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.arcTo(x + width, y, x + width, y + radius, radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius);
    ctx.lineTo(x + radius, y + height);
    ctx.arcTo(x, y + height, x, y + height - radius, radius);
    ctx.lineTo(x, y + radius);
    ctx.arcTo(x, y, x + radius, y, radius);
    ctx.closePath();
  };

  const renderCardFlipAnimation = (
    ctx: CanvasRenderingContext2D,
    animatingCard: any,
    deck: any[],
    drawnCards: any[],
    canvas: HTMLCanvasElement,
    cardImg: HTMLImageElement | null,
    drawCachedWrappedText: Function,
    drawRoundedRect: Function
  ) => {
    if (!animatingCard) return;
  
    const { card, progress, direction } = animatingCard;
    const width = canvas.width;
    const height = canvas.height;
  
    const cardWidth = width * 0.425;
    const cardHeight = height * 0.555;
    const borderRadius = 20;
  
    const deckX = width * 0.03;
    const deckY = height * 0.3;
    const drawnX = width * 0.54;
    const drawnY = height * 0.24;
  
    const cardSpacing = 3;
    let lastY = 0;
    deck.forEach((_, i) => {
      if (i <= 20) {
        lastY = deckY - i * cardSpacing;
      }
    });
  
    if (direction === "draw") {
      const startX = deckX;
      const endX = drawnX;
      const startY = (deck.length - 1) <= 20 ? (deckY - (deck.length - 1) * cardSpacing) : lastY;
      const endY = drawnY;
      const moveProgress = Math.min(progress, 1);
      const flipProgress = Math.max(progress - 1, 0);
      const x = startX + (endX - startX) * moveProgress;
      const y = startY + (endY - startY) * moveProgress;
  
      ctx.save();
      ctx.translate(x + cardWidth / 2, y + cardHeight / 2);
      const scaleX = flipProgress > 0 ? Math.cos(flipProgress * Math.PI) * -1 : 1;
      ctx.scale(scaleX, 1);
      ctx.translate(-cardWidth / 2, -cardHeight / 2);
  
      if (flipProgress === 0 && cardImg) {
        ctx.drawImage(cardImg, 0, 0, cardWidth, cardHeight);
      }
  
      if (flipProgress > 0) {
        if (scaleX < 0 && cardImg) {
          ctx.save();
          ctx.translate(cardWidth, 0);
          ctx.scale(-1, 1);
          ctx.drawImage(cardImg, 0, 0, cardWidth, cardHeight);
          ctx.restore();
        } else {
          ctx.fillStyle = "#ffffff";
          drawRoundedRect(ctx, 0, 0, cardWidth, cardHeight, borderRadius);
          ctx.fill();
          ctx.strokeStyle = "#5d5b53";
          ctx.stroke();
        }
  
        if (scaleX > 0) {
          ctx.save();
          ctx.translate(cardWidth / 2, cardHeight / 2);
          ctx.fillStyle = "#5d5b53";
          drawCachedWrappedText(ctx, card.text, 0, 0, cardWidth * 0.9, cardWidth / 5, 24);
          ctx.restore();
        }
      }
      ctx.restore();
    } else {
      const flipProgress = Math.min(progress, 1);
      const moveProgress = Math.max(progress - 1, 0);
      const startX = drawnX;
      const endX = deckX;
      const startY = drawnY;
      const endY = (deck.length) <= 20 ? (deckY - deck.length * cardSpacing) : lastY;
      const x = startX + (endX - startX) * moveProgress;
      const y = startY + (endY - startY) * moveProgress;
  
      ctx.save();
      ctx.translate(x + cardWidth / 2, y + cardHeight / 2);
      const scaleX = flipProgress < 1 ? Math.cos(flipProgress * Math.PI) : -1;
      ctx.scale(scaleX, 1);
      ctx.translate(-cardWidth / 2, -cardHeight / 2);
  
      if (flipProgress < 1 && scaleX > 0) {
        ctx.fillStyle = "#ffffff";
        drawRoundedRect(ctx, 0, 0, cardWidth, cardHeight, borderRadius);
        ctx.fill();
        ctx.strokeStyle = "#5d5b53";
        ctx.stroke();
        ctx.fillStyle = "#5d5b53";
        ctx.translate(cardWidth / 2, cardHeight / 2);
        drawCachedWrappedText(ctx, card.text, 0, 0, cardWidth * 0.9, cardWidth / 5, 24);
      } else if (cardImg) {
        ctx.save();
        ctx.translate(cardWidth, 0);
        ctx.scale(-1, 1);
        ctx.drawImage(cardImg, 0, 0, cardWidth, cardHeight);
        ctx.restore();
      }
  
      if (moveProgress > 0 && scaleX < 0 && cardImg) {
        ctx.save();
        ctx.translate(cardWidth, 0);
        ctx.scale(-1, 1);
        ctx.drawImage(cardImg, 0, 0, cardWidth, cardHeight);
        ctx.restore();
      }
  
      ctx.restore();
    }
  };  

  // 將 "靜態卡片（已抽、未抽）" 獨立為純繪製函式
  // 注意：此函式不處理動畫狀態，也不繪製標題與按鈕
  const renderStaticCards = ({
    ctx,
    width,
    height,
    deck,
    drawnCards,
    cardImg,
    config,
    cardTitle
  }: {
    ctx: CanvasRenderingContext2D;
    width: number;
    height: number;
    deck: any[];
    drawnCards: any[];
    cardImg: React.MutableRefObject<HTMLImageElement | null>;
    config: any;
    cardTitle: string;
  }) => {
    const cardWidth = width * 0.425;
    const cardHeight = height * 0.555;
    const borderRadius = 20;
  
    const deckX = width * 0.03;
    const deckY = height * 0.3;
    let lastY = 0;
    let cardSpacing = 3;
  
    // 顯示牌堆
    deck.forEach((_, i) => {
      cardSpacing = (i % 5 === 0) ? 3.03 : 3;
      const cardX = deckX;
      const cardY = i <= 20 ? (deckY - i * cardSpacing) : lastY;
      if (i <= 20) lastY = cardY;
      if (cardImg.current) {
        ctx.drawImage(cardImg.current, cardX, cardY, cardWidth, cardHeight);
      }
      // ctx.lineWidth = 2;
      // ctx.strokeStyle = "#5d5b53";
      // ctx.stroke();
    });
  
    // 顯示已抽卡片（最上方那張）
    const drawnX = width * 0.54;
    const drawnY = height * 0.24;
  
    ctx.fillStyle = "#efefef";
    drawRoundedRect(ctx, drawnX - 8, drawnY - 8, cardWidth + 16, cardHeight + 16, borderRadius);
    ctx.fill();
    ctx.strokeStyle = "#5d5b53";
    ctx.setLineDash([10, 10]);
    ctx.lineWidth = 5;
    drawRoundedRect(ctx, drawnX - 8, drawnY - 8, cardWidth + 16, cardHeight + 16, borderRadius);
    ctx.stroke();
    ctx.setLineDash([]);
  
    if (drawnCards.length > 0) {
      const lastCard = drawnCards[drawnCards.length - 1];
      ctx.fillStyle = "#ffffff";
      drawRoundedRect(ctx, drawnX, drawnY, cardWidth, cardHeight, borderRadius);
      ctx.fill();
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#5d5b53";
      ctx.stroke();
      ctx.fillStyle = "#5d5b53";
      const maxFontSize = cardWidth / 5;
      const minFontSize = 24;
      drawCachedWrappedText(
        ctx,
        lastCard.text,
        drawnX + cardWidth / 2,
        drawnY + cardHeight / 2,
        cardWidth * 0.9,
        maxFontSize,
        minFontSize
      );
    }
  };

  const renderStaticCanvas = () => {
    const canvas = staticCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
  
    const width = canvas.width;
    const height = canvas.height;
  
    ctx.clearRect(0, 0, width, height);
  
    const cardWidth = width * 0.425;
    const cardHeight = height * 0.555;
    const borderRadius = 20;
    const drawnX = width * 0.54;
    const drawnY = height * 0.24;
  
    // 標題
    ctx.fillStyle = config.theme === "theme3" ? "#ffffff" : "#5d5b53";
    const maxFontSize = 60;
    const minFontSize = 16;
    drawCachedWrappedText(
      ctx,
      cardTitle,
      width / 2,
      height * 0.12,
      width * 0.5,
      maxFontSize,
      minFontSize
    );
  
    // 右側卡片框
    ctx.fillStyle = "#efefef";
    drawRoundedRect(ctx, drawnX - 8, drawnY - 8, cardWidth + 16, cardHeight + 16, borderRadius);
    ctx.fill();
    ctx.strokeStyle = "#5d5b53";
    ctx.setLineDash([10, 10]);
    ctx.lineWidth = 5;
    drawRoundedRect(ctx, drawnX - 8, drawnY - 8, cardWidth + 16, cardHeight + 16, borderRadius);
    ctx.stroke();
    ctx.setLineDash([]);
  
    // 按鈕框
    if (!username) {
      const buttonWidth = Math.floor(width * 0.078);
      const buttonHeight = Math.floor(height * 0.1116);
      const buttonY = height * 0.847;
  
      const x = width * 0.80 + buttonWidth;
      drawRoundedRect(ctx, x, buttonY, buttonWidth, buttonHeight, 6);
      if (buttonImg.current) {
        ctx.drawImage(buttonImg.current, x, buttonY, buttonWidth, buttonHeight);
      }
    }

    renderStaticCards({ ctx, width, height, deck, drawnCards, cardImg, config, cardTitle });
  };




  const handleCanvasClick = useCallback((e: MouseEvent | TouchEvent) => {
    const DIV = coverRef.current;
    if (!DIV) return;
    if (isShuffling) return;
  
    const rect = DIV.getBoundingClientRect();
    const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
    const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;

    const rawX = (clientX - rect.left);
    const rawY = (clientY - rect.top);

    const deckX = rect.width * 0.03;
    const deckY = rect.height * 0.3;
    const cardWidth = rect.width * 0.425;
    const cardHeight = rect.height * 0.555;
  
    const drawnX = rect.width * 0.54;
    const drawnY = rect.height * 0.24;
  
    const buttonWidth = Math.floor(rect.width * 0.078);
    const buttonHeight = Math.floor(rect.height * 0.1116);
    const buttonY = rect.height * 0.847;
  
    let clicked = false;
    const x = rect.width * 0.80 + buttonWidth;
    if (
      !Spotlighting &&
      rawX >= x &&
      rawX <= x + buttonWidth &&
      rawY >= buttonY &&
      rawY <= buttonY + buttonHeight
    ) {
      shuffleDeck();
      clicked = true;
    }
  
    if (
      !Spotlighting &&
      rawX >= deckX &&
      rawX <= deckX + cardWidth &&
      rawY >= deckY - deck.length * 5 &&
      rawY <= deckY + cardHeight
    ) {
      drawCard();
      clicked = true;
    } else if (
      !Spotlighting &&
      rawX >= drawnX - 20 &&
      rawX <= drawnX + cardWidth + 20 &&
      rawY >= drawnY - 20 &&
      rawY <= drawnY + cardHeight + 20
    ) {
      recallCard();
      clicked = true;
    }
  
    if (!clicked) {
      const currentTimestamp = Date.now();
      if (currentTimestamp - lastTapTimestamp < 300) {
        setSpotlighting(true);
        itemSpotlight();
        setTimeout(() => {
          setSpotlighting(false);
        }, 1000);
      }
      setLastTapTimestamp(currentTimestamp);
    }
  }, [deck, drawnCards, Spotlighting, lastTapTimestamp]);

  const handleMouseMove = useCallback((e: MouseEvent | TouchEvent) => {
    const DIV = coverRef.current;
    if (!DIV) return;
  
    const rect = DIV.getBoundingClientRect();
    const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
    const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
    const mouseX = clientX - rect.left;
    const mouseY = clientY - rect.top;
  
    const deckX = rect.width * 0.03;
    const deckY = rect.height * 0.3;
    const cardWidth = rect.width * 0.425;
    const cardHeight = rect.height * 0.555;
  
    const drawnX = rect.width * 0.54;
    const drawnY = rect.height * 0.24;
  
    const buttonWidth = Math.floor(rect.width * 0.078);
    const buttonHeight = Math.floor(rect.height * 0.1116);
    const buttonY = rect.height * 0.847;
  
    let isHovering = false;
  
    const x = rect.width * 0.80 + buttonWidth;
    if (
      mouseX >= x &&
      mouseX <= x + buttonWidth &&
      mouseY >= buttonY &&
      mouseY <= buttonY + buttonHeight
    ) {
      isHovering = true;
    }
  
    if (
      mouseX >= deckX &&
      mouseX <= deckX + cardWidth &&
      mouseY >= deckY - deck.length * 5 &&
      mouseY <= deckY + cardHeight
    ) {
      isHovering = true;
    }
    else if (
      mouseX >= drawnX - 20 &&
      mouseX <= drawnX + cardWidth + 20 &&
      mouseY >= drawnY - 20 &&
      mouseY <= drawnY + cardHeight + 20
    ) {
      isHovering = true;
    }
  
    DIV.style.cursor = isHovering ? "pointer" : "default";
  }, [deck.length, drawnCards.length]);

  useEffect(() => {
    const canvas = staticCanvasRef.current;
    const animCanvas = animationCanvasRef.current;
    if (!canvas && !animCanvas) return;
    
    const resizeCanvas = () => {
      if (canvas && animCanvas) {
        const width = config.spotlight ? 1920 : config.width;
        const height = config.spotlight ? 1080 : config.height;
        canvas.width = width;
        canvas.height = height;

        animCanvas.width = width;
        animCanvas.height = height;
        renderStaticCanvas();
      }
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    return () => {
      window.removeEventListener("resize", resizeCanvas);
    };
  }, [handleCanvasClick, handleMouseMove, config.height, config.width]);

  useEffect(() => {
    const DIV = coverRef.current;
    if (!DIV) return;

    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouchDevice) {
      DIV.addEventListener("touchstart", handleCanvasClick, { passive: true });
    } else {
      DIV.addEventListener("click", handleCanvasClick);
    }
    DIV.addEventListener("mousemove", handleMouseMove);

    return () => {
      if (isTouchDevice) {
        DIV.removeEventListener("touchstart", handleCanvasClick);
      } else {
        DIV.removeEventListener("click", handleCanvasClick);
      }
      DIV.removeEventListener("mousemove", handleMouseMove);
    };
  }, [handleCanvasClick, handleMouseMove, coverRef.current]);

  return (
    <React.Fragment>
      {config.data && !config.data.start? (
        <div className="absolute top-0 start-0 origin-left-top" style={{ ...inside }}>
          <div style={{ height: '100%', width: '100%', position: 'absolute' }}>
            <div className="relative flex h-full flex-col items-center justify-center p-6 bg-screen  overflow-hidden" style={{ cursor: 'auto' }}>
              <div className="widget-head">
                <img className="widget-img-icon" src={widgetCard} alt="" />
              </div>
              <p className="text-dark-500 mb-6 px-4 text-center text-xl font-semibold transition-[color]">翻卡片</p>
              <Button
                color="light"
                className={`ts-playBtn settingBtn btn-load rounded-pill text-sm px-4 h-12 font-semibold`}
                onClick={() => setIsOpen(true)}
                data-interaction-target-type="false"
              >
                <div className="relative justify-center h-100 w-100">
                  <span className="flex items-center justify-center w-100">
                    設定
                  </span>
                </div>
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ height: '100%', width: '100%', position: 'absolute' }}>
          <Box className="h-100">
            <div className="card-container">
              <canvas ref={staticCanvasRef} style={{ position: 'absolute', top: 0, left: 0, zIndex: 0, pointerEvents: "none" }} />
              <canvas ref={animationCanvasRef} style={{ position: 'absolute', top: 0, left: 0, zIndex: 1, pointerEvents: "none" }} />
              
              {config.selected && hoverCard? (
                <Portal visible={nowPage}>
                  <div
                    ref={coverRef}
                    style={{
                      height: (popupRef.current?.getBoundingClientRect().height ?? 0) * (isIPad? zoom : 1),
                      width: (popupRef.current?.getBoundingClientRect().width ?? 0) * (isIPad? zoom : 1),
                      position: 'absolute',
                      top: (popupRef.current?.getBoundingClientRect().y ?? 0) * (isIPad? zoom : 1),
                      left: (popupRef.current?.getBoundingClientRect().x ?? 0) * (isIPad? zoom : 1),
                      zIndex: 9999
                    }}
                    data-interaction-ignore-drag={false}
                    data-interaction-target-type={true}
                  >
                  </div>
                </Portal>
              ) : null}
            </div>
          </Box>
        </div>
      )}
      {username? (
        <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
      ) : null}
    </React.Fragment>
  );
};

export default memo(Index);